import { render, staticRenderFns } from "./AddAdvertsPiano.vue?vue&type=template&id=4b222adc&scoped=true"
import script from "./AddAdvertsPiano.vue?vue&type=script&lang=js"
export * from "./AddAdvertsPiano.vue?vue&type=script&lang=js"
import style0 from "./AddAdvertsPiano.vue?vue&type=style&index=0&id=4b222adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b222adc",
  null
  
)

export default component.exports